/**
 * Server-side structured data for the RelocationTiming tool page.
 * Lives in a data module (not the page component) so routeMeta can emit it
 * into the server HTML; react-helmet would only add it after hydration.
 */
import { RELOCATION_FAQS } from "@/data/relocationTimingData";

export const PAGE_URL = "https://www.homeapproach.com/tools/relocation-timing";

  export const RELOCATION_TIMING_JSON_LD: Record<string, unknown> = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebPage",
      name: "How to Time Selling Your Home and Buying in Another City",
      description:
        "Sell first, buy first, or close simultaneously: how to time a cross-city move, which financing tools bridge the gap, how to coordinate two agents and two closers, and a dated relocation checklist.",
      url: PAGE_URL,
      inLanguage: "en-US",
      isPartOf: { "@type": "WebSite", name: "Home Approach", url: "https://www.homeapproach.com" },
      publisher: {
        "@type": "Organization",
        name: "Home Approach",
        url: "https://www.homeapproach.com",
        logo: { "@type": "ImageObject", url: "https://www.homeapproach.com/og-image.png" },
      },
    },
    {
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://www.homeapproach.com/" },
        { "@type": "ListItem", position: 2, name: "Tools", item: "https://www.homeapproach.com/tools" },
        {
          "@type": "ListItem",
          position: 3,
          name: "How to Time Selling Your Home and Buying in Another City",
          item: PAGE_URL,
        },
      ],
    },
    {
      "@type": "FAQPage",
      mainEntity: RELOCATION_FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    },
  ],
};
